// extracted by mini-css-extract-plugin
module.exports = {"ButtonWrapper":"Button_ButtonWrapper__1YXc2","FormButtonWrapper":"Button_FormButtonWrapper__25wk_"};